import React, { useState } from "react";
import { Container, Row, Col, Tab, Nav, Spinner } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/smartparking.png";
import projImg2 from "../assets/img/travelapp.png";
import projImg3 from "../assets/img/website1.png";
import projImg4 from "../assets/img/recpiseapp.png";
import projImg5 from "../assets/img/websit2.png";
import projImg6 from "../assets/img/elearning.png";
import projImg7 from "../assets/img/website3.png";
import projui1 from "../assets/img/uidesign.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const [activeCategory, setActiveCategory] = useState("first");
  const [loading, setLoading] = useState(false);

  const projects = [
    {
      title: "Smart Parking App",
      description: "React Native , Spring Boot",
      imgUrl: projImg1,
      category: "first",
    },
    {
      title: "Elearning App",
      description: "React Native , Laravel",
      imgUrl: projImg6,
      category: "first",
    },
    {
      title: "Travel App UI",
      description: "React Native",
      imgUrl: projImg2,
      category: "first",
    },
    {
      title: "Recipes App UI",
      description: "React Native",
      imgUrl: projImg4,
      category: "first",
    },
    {
      title: "Video Game Review Website ",
      description: "React Js , Laravel",
      imgUrl: projImg3,
      category: "second",
    },
    {
      title: "Ecommerce Website",
      description: "Laravel Blade",
      imgUrl: projImg5,
      category: "second",
    },
    {
      title: "LMS Website",
      description: "React JS , Laravel",
      imgUrl: projImg7,
      category: "second",
    },
    {
      title: "UI&UX Bike Website",
      description: "FIGMA DESIGN",
      imgUrl: projui1,
      category: "third",
    },
  ];

  const filteredProjects = projects.filter(
    (project) => project.category === activeCategory
  );

  const handleTabClick = (category) => {
    setLoading(true);
    setActiveCategory(category);
    setTimeout(() => setLoading(false), 500); // Adjust the delay as needed
  };

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    Welcome to my project portfolio, where creativity meets
                    functionality!
                  </p>
                  <Tab.Container
                    id="projects-tabs"
                    defaultActiveKey={activeCategory}
                  >
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link
                          eventKey="first"
                          onClick={() => handleTabClick("first")}
                        >
                          Mobile
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="second"
                          onClick={() => handleTabClick("second")}
                        >
                          Web
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="third"
                          onClick={() => handleTabClick("third")}
                        >
                          UI & UX
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      {loading ? (
                        <div className="text-center">
                          <Spinner animation="border" variant="primary" />
                        </div>
                      ) : (
                        <Tab.Pane eventKey={activeCategory}>
                          <Row>
                            {filteredProjects.map((project, index) => (
                              <ProjectCard key={index} {...project} />
                            ))}
                          </Row>
                        </Tab.Pane>
                      )}
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img
        className="background-image-right"
        src={colorSharp2}
        alt="background"
      ></img>
    </section>
  );
};
